import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import NavigationBar from "./components/NavigationBar.jsx";
import Footer from "./components/Footer.jsx";
import HomePage from "./pages/HomePage.jsx";
import MeetingsPage from "./pages/MeetingPage.jsx";
import CoursesPage from "./pages/CoursesPage.jsx";
import CourseDetailsPage from "./pages/CourseDetailsPage";
import CourseContentPage from "./pages/CourseContentPage";
import {AuthProvider} from "./contexts/AuthContext";
import ProtectedRoute from "./ProtectedRoute";
import BrandingSignInPage from "./pages/SigninPage";
import SignUp from "./pages/SignupPage.jsx";
import AboutPage from "./pages/AboutPage";
import OurMissionPage from "./pages/OurMissionPage";
import OurVisionPage from "./pages/OurVisionPage";
import LoadingScreen from "./components/LoadingScreen";
import {useEffect, useState} from "react";
import FounderMessage from "./pages/FounderMessage";

function App() {

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 2000); // Simulate a 2-second loading time
        return () => clearTimeout(timer);
    }, []);
    if (loading) {
        return <LoadingScreen/>;
    }

    return (
        <AuthProvider>
            <Router>
                <NavigationBar/>
                <Routes>
                    <Route path="/" element={<Navigate to="/home" replace/>}/>
                    <Route path="/home" element={<HomePage/>}/>
                    <Route path="/meetings" element={<MeetingsPage/>}/>



                    {/*<Route path="/courses" element={<CoursesPage />} />*/}
                    <Route element={<ProtectedRoute/>}>
                        <Route path="/course-content/:courseId" element={<CourseContentPage/>}/>
                    </Route>

                    <Route path="/about" element={<AboutPage/>}/>
                    <Route path="/our-mission" element={<OurMissionPage/>}/>
                    <Route path="/our-vision" element={<OurVisionPage/>}/>
                    <Route path="/course-details/:id" element={<CourseDetailsPage/>}/>
                    <Route path="/signin" element={<BrandingSignInPage/>}/>
                    <Route path="/signup" element={<SignUp/>}/>
                    <Route path="/founder-message" element={<FounderMessage/>}/>
                    <Route path="/courses" element={<CoursesPage/>}/>
                    <Route path="*" element={<Navigate to="/home" replace/>}/>
                </Routes>
                <Footer/>
            </Router>
        </AuthProvider>
    );
}

export default App;
